module.exports = __webpack_public_path__ + "img/icon-turno.b0707bfc.svg";